var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.0297 1.12265L20.8145 7.69811L-5.33544e-08 7.69812L1.67487e-08 9.30189L20.8145 9.30189L14.0297 15.8774L15.2295 17L22.8416 9.62264L24 8.5L22.8416 7.37736L15.2295 3.149e-06L14.0297 1.12265Z","fill":"#020430"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"17","height":"24","fill":"white","transform":"translate(0 17) rotate(-90)"})))]);
}

ArrowR.defaultProps = {"width":"24","height":"17","viewBox":"0 0 24 17","fill":"none"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
